import { ChartSeries } from './index';
import type { IRadarChartSerData } from '@tencent/slide-sdk-model';
import type { SerRules } from './index';
import type {
    IRadarChartSeries,
} from '@src/slide/domain/ui-model/element-modeles/Interface/chart-v3/sub-chart/radar-chart.interface';

export class RadarChartSeries extends ChartSeries implements IRadarChartSeries {
    public constructor(serData: IRadarChartSerData, options: SerRules) {
        super(serData, options);
    }
}
